export const getPaymentList = () => {
  const token = localStorage.getItem("token");
  const reqestURL = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_V}/payments`;
  const reqestHeader = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  return fetch(reqestURL, {
    method: "GET",
    headers: reqestHeader,
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const addPayment = (input) => {
  const token = localStorage.getItem("token");
  const reqestURL = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_V}/payments`;
  const reqestHeader = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  return fetch(reqestURL, {
    method: "POST",
    headers: reqestHeader,
    body: JSON.stringify(input),
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getPaymentUserList = (uid) => {
  const token = localStorage.getItem("token");
  const reqestURL = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_V}/payments?user_id=${uid}`;
  const reqestHeader = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  return fetch(reqestURL, {
    method: "GET",
    headers: reqestHeader,
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
